module.exports = __webpack_public_path__ + "static/media/pod_pass.6eb26528.svg";